import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../../utils/tools/cn';

// Icon
import { ReactComponent as LoaderSvg } from '../../../assets/icons/loader.svg';

import styles from './Button.module.scss';

function Button({
  children, theme, disabled, isLoading, onClick, full, submitType, className,
}) {
  return (
    <button
      type={submitType ? 'submit' : 'button'}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={cn([
        'd-flex a-center j-center text-left font-secondary fw-500',
        styles.button,
        theme ? styles[theme] : '',
        full ? 'w-100' : '',
        className,
      ])}
    >
      {isLoading ? <LoaderSvg width={20} height={20} className="m-r-15" /> : null}
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['inverted', 'white', 'inverted-white', 'red']),
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  full: PropTypes.bool,
  submitType: PropTypes.bool,
  className: PropTypes.string,
};

Button.defaultProps = {
  theme: null,
  disabled: false,
  isLoading: false,
  onClick: () => {},
  full: false,
  submitType: false,
  className: '',
};

export default Button;
